export default __webpack_public_path__ + "static/media/foto_cat2.3129bc18.jpg";